module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-arrow-up-fill-a97ed460.svg";